import { Skeleton } from '@mntn/ui-components'
import { OfferingCard, OfferingCardSkeleton } from '@/components/shared'
import type { LayoutType } from '@/components/shared/types'

interface Props {
  offeringName: string
  coverMediaUrl: string | null
  onViewDetails: () => void
  layout?: LayoutType
}

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const DealInfo: React.FC<Props> = ({ offeringName, coverMediaUrl, onViewDetails, layout = 'list' }) => {
  if (layout === 'grid') {
    return (
      <div className="flex flex-col items-center gap-4 w-full">
        <div className="relative group w-full flex flex-col items-center">
          <OfferingCard
            imageProps={{
              src: coverMediaUrl || '',
              alt: `${offeringName} feature image`,
            }}
            size="full"
            handleClick={onViewDetails}
          />
          <div
            className="absolute bottom-0 left-0 w-full h-8"
            style={{
              background: 'linear-gradient(0deg, rgb(var(--surface-bg-inverse)) 59.4%, rgba(0, 0, 0, 0.00) 99.82%)',
            }}
          />
        </div>
      </div>
    )
  }

  return (
    <div className="relative group shrink-0">
      <OfferingCard
        imageProps={{
          src: coverMediaUrl || '',
          alt: `${offeringName} feature image`,
        }}
        size="sm"
        handleClick={onViewDetails}
      />
    </div>
  )
}

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const DealInfoSkeleton: React.FC<{ layout?: LayoutType }> = ({ layout = 'list' }) => {
  if (layout === 'grid') {
    return (
      <div className="flex flex-col items-center w-full gap-4">
        <OfferingCardSkeleton size="full" />
        <div className="w-full flex flex-col">
          <Skeleton dark className="w-1/3 h-6" />
        </div>
      </div>
    )
  }
  return <OfferingCardSkeleton size="sm" />
}
